import React from 'react';
import { BookOpenIcon, PlayIcon, TrendingDownIcon, TrendingUpIcon, RepeatIcon, CalendarIcon, FlameIcon, MonitorIcon, LayoutIcon, CheckIcon, MailIcon, SplitIcon, BarChart2Icon, Repeat2Icon, TimerIcon, MessageCircleIcon, ThumbsDownIcon, BookMarkedIcon, QuoteIcon, ZapIcon } from 'lucide-react';
import type { Metric, WeeklyRead, ChapterDropoff, DeviceDataItem, ReadingMethodItem, Book, AdvancedMetric } from './types';
export const metrics: Metric[] = [{
  icon: <BookOpenIcon className="w-5 h-5 text-indigo-600" data-id="element-5895" data-mp="29elqve3amsfo" />,
  title: 'Total Downloads',
  description: 'How many readers have added your book to their shelf or library.',
  value: '2,458',
  change: '+12%',
  isPositive: true
}, {
  icon: <PlayIcon className="w-5 h-5 text-indigo-600" data-id="element-5896" data-mp="twsanp3i6ysr" />,
  title: 'Start Rate',
  description: 'Of those who downloaded, how many actually started reading?',
  value: '82%',
  change: '+3%',
  isPositive: true
}, {
  icon: <TrendingUpIcon className="w-5 h-5 text-indigo-600" data-id="element-5897" data-mp="45ln4wois1ga" />,
  title: 'Average Read Depth',
  description: 'See how far readers are getting — by page count or percentage.',
  value: '68%',
  change: '+5%',
  isPositive: true
}, {
  icon: <TrendingDownIcon className="w-5 h-5 text-indigo-600" data-id="element-5898" data-mp="3rcw0ox03xbea" />,
  title: 'Drop-off Points',
  description: 'Where most readers stop — so you can adjust or investigate.',
  value: 'Ch. 7',
  change: 'No change',
  isPositive: null
}, {
  icon: <CheckIcon className="w-5 h-5 text-indigo-600" data-id="element-5899" data-mp="3mci1m4ghhbse" />,
  title: 'Completion Rate',
  description: "How many readers finish the book — and where they stop if they don't.",
  value: '64%',
  change: '+2%',
  isPositive: true
}, {
  icon: <RepeatIcon className="w-5 h-5 text-indigo-600" data-id="element-5900" data-mp="2ylvv4hm4nzki" />,
  title: 'Rereads & Returns',
  description: 'See if readers revisit key scenes or come back for a second round.',
  value: '18%',
  change: '+4%',
  isPositive: true
}, {
  icon: <CalendarIcon className="w-5 h-5 text-indigo-600" data-id="element-5901" data-mp="195jta574cc7v" />,
  title: 'Read Trends Over Time',
  description: 'Visualize reading activity over days or weeks.',
  value: 'Upward',
  change: 'Trending up',
  isPositive: true
}, {
  icon: <FlameIcon className="w-5 h-5 text-indigo-600" data-id="element-5902" data-mp="vdc0spmvb7ez" />,
  title: 'Engagement Heatmap',
  description: 'Color-coded overview of reading intensity throughout the book.',
  value: 'High',
  change: 'Ch. 8-12',
  isPositive: true
}, {
  icon: <LayoutIcon className="w-5 h-5 text-indigo-600" data-id="element-5903" data-mp="1o3c5andgiihb" />,
  title: 'Reading Method Breakdown',
  description: 'Whether readers used the app, browser, or download option.',
  value: 'App: 68%',
  change: 'Browser: 32%',
  isPositive: null
}, {
  icon: <MonitorIcon className="w-5 h-5 text-indigo-600" data-id="element-5904" data-mp="7oamwmv9n42b" />,
  title: 'Device Types',
  description: 'Find out if readers are on mobile, tablet, desktop, or e-reader.',
  value: 'Mobile: 72%',
  change: 'Other: 28%',
  isPositive: null
}];
export const weeklyReads: WeeklyRead[] = [{
  day: 'Mon',
  count: 142
}, {
  day: 'Tue',
  count: 165
}, {
  day: 'Wed',
  count: 192
}, {
  day: 'Thu',
  count: 178
}, {
  day: 'Fri',
  count: 211
}, {
  day: 'Sat',
  count: 243
}, {
  day: 'Sun',
  count: 189
}];
export const chapterDropoffs: ChapterDropoff[] = [{
  chapter: 1,
  dropoffRate: 2
}, {
  chapter: 2,
  dropoffRate: 3
}, {
  chapter: 3,
  dropoffRate: 5
}, {
  chapter: 4,
  dropoffRate: 4
}, {
  chapter: 5,
  dropoffRate: 6
}, {
  chapter: 6,
  dropoffRate: 8
}, {
  chapter: 7,
  dropoffRate: 15
}, {
  chapter: 8,
  dropoffRate: 9
}, {
  chapter: 9,
  dropoffRate: 7
}, {
  chapter: 10,
  dropoffRate: 6
}, {
  chapter: 11,
  dropoffRate: 5
}, {
  chapter: 12,
  dropoffRate: 7
}, {
  chapter: 13,
  dropoffRate: 8
}, {
  chapter: 14,
  dropoffRate: 6
}, {
  chapter: 15,
  dropoffRate: 9
}];
export const deviceData: DeviceDataItem[] = [{
  device: 'Mobile',
  percentage: 72
}, {
  device: 'Tablet',
  percentage: 15
}, {
  device: 'Desktop',
  percentage: 10
}, {
  device: 'E-Reader',
  percentage: 3
}];
export const readingMethodData: ReadingMethodItem[] = [{
  method: 'In-App',
  percentage: 68
}, {
  method: 'Browser',
  percentage: 22
}, {
  method: 'Downloaded',
  percentage: 10
}];
export const books: Book[] = [{
  id: 1,
  title: 'The Silent Echo',
  coverImage: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
  downloads: 2458,
  startRate: 82,
  completionRate: 64,
  averageReadDepth: 68,
  mainDropoffChapter: 7,
  author: 'Elena Richards'
}, {
  id: 2,
  title: 'Beyond the Veil',
  coverImage: 'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
  downloads: 1876,
  startRate: 78,
  completionRate: 59,
  averageReadDepth: 62,
  mainDropoffChapter: 5,
  author: 'Elena Richards'
}, {
  id: 3,
  title: 'Midnight Shadows',
  coverImage: 'https://images.unsplash.com/photo-1621351183012-e2f9972dd9bf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
  downloads: 1245,
  startRate: 85,
  completionRate: 71,
  averageReadDepth: 76,
  mainDropoffChapter: 9,
  author: 'Sarah Johnson'
}, {
  id: 4,
  title: 'Whispers in the Dark',
  coverImage: 'https://images.unsplash.com/photo-1598646506899-ac6be1060f4b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
  downloads: 1872,
  startRate: 79,
  completionRate: 68,
  averageReadDepth: 72,
  mainDropoffChapter: 6,
  author: 'Sarah Johnson'
}, {
  id: 5,
  title: 'Heart of the Storm',
  coverImage: 'https://images.unsplash.com/photo-1516979187457-637abb4f9353?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800',
  downloads: 3145,
  startRate: 88,
  completionRate: 75,
  averageReadDepth: 81,
  mainDropoffChapter: 10,
  author: 'Marcus Chen'
}];
export const advancedMetrics: AdvancedMetric[] = [{
  id: 'notify-readers',
  icon: <MailIcon className="w-5 h-5 text-teal-600" data-id="element-5905" data-mp="3s4vuf7t3z5gh" />,
  title: 'Notify Readers of New Release',
  description: 'Send an update to everyone who finished Book 1 — ideal for sequels or announcements.',
  details: 'Reach out to your most engaged readers at the perfect moment. This tool identifies readers who have completed your previous books and allows you to notify them directly when you release a sequel or new work. Increase conversion rates by targeting readers who already enjoy your writing style.'
}, {
  id: 'ab-testing',
  icon: <SplitIcon className="w-5 h-5 text-teal-600" data-id="element-5906" data-mp="17hsooyuy2784" />,
  title: 'A/B Test Covers or Descriptions',
  description: 'Compare performance between different blurbs or covers to see what gets more reads.',
  details: 'Test multiple versions of your book covers or descriptions to see which performs better with readers. Our A/B testing tool shows you real data on which version leads to more downloads, longer reading sessions, and higher completion rates. Make data-driven decisions about your book presentation.'
}, {
  id: 'genre-benchmarking',
  icon: <BarChart2Icon className="w-5 h-5 text-teal-600" data-id="element-5907" data-mp="11093k7d5fau2" />,
  title: 'Genre Benchmarking',
  description: 'See how your book performs compared to others in the same genre (downloads, read depth, etc).',
  details: "Compare your book's performance metrics against anonymized data from other books in your genre. See where you stand in terms of download rates, reader engagement, completion percentages, and more. Identify opportunities to improve your book's performance relative to genre standards."
}, {
  id: 'series-performance',
  icon: <Repeat2Icon className="w-5 h-5 text-teal-600" data-id="element-5908" data-mp="37i5x1tjvmj8n" />,
  title: 'Series Performance Comparison',
  description: 'Track reader flow from Book 1 through the rest of your series with completion and drop-off rates.',
  details: 'Visualize how readers move through your series with detailed funnel analysis. See completion rates for each book, identify where readers drop off between books, and understand reading patterns across your entire series. Perfect for optimizing your series strategy and improving reader retention.'
}, {
  id: 'marketing-tools',
  icon: <ZapIcon className="w-5 h-5 text-teal-600" data-id="element-5909" data-mp="40nn9gkjn25l" />,
  title: 'Marketing & Outreach Tools',
  description: 'Discover your top referral sources, email opt-ins, and spikes linked to campaigns or features.',
  details: 'Track the effectiveness of your marketing efforts with comprehensive analytics on referral sources, promotional campaigns, and reader acquisition channels. Measure email list conversion rates, monitor social media effectiveness, and identify which marketing activities drive the most engaged readers.'
}, {
  id: 'sales-conversion',
  icon: <BarChart2Icon className="w-5 h-5 text-teal-600" data-id="element-5910" data-mp="6kkaysdwzztn" />,
  title: 'Sales & Conversion Stats',
  description: 'Track conversions from preview to download, price sensitivity, and reader behavior before/after purchase.',
  details: 'Analyze the complete reader journey from initial discovery to purchase and beyond. Understand how preview readers convert to buyers, test different price points to find optimal pricing, and see how reader behavior changes after purchase. Maximize your revenue while maintaining reader satisfaction.'
}, {
  id: 'reader-polls',
  icon: <MessageCircleIcon className="w-5 h-5 text-teal-600" data-id="element-5911" data-mp="1i08v7bzsakqr" />,
  title: 'Embedded Reader Polls',
  description: 'Embed chapter-end polls and view live results to gauge reader opinions in real time.',
  details: 'Get direct feedback from readers by embedding customizable polls at strategic points in your book. Ask readers about character preferences, plot developments, or reading experience. Collect valuable insights that can inform your future writing and marketing decisions.'
}, {
  id: 'time-to-read',
  icon: <TimerIcon className="w-5 h-5 text-teal-600" data-id="element-5912" data-mp="2v8rt4lqer1kg" />,
  title: 'Time to First Read',
  description: 'Measure the average delay between download and when readers start your book.',
  details: 'Understand how quickly readers engage with your book after downloading it. Identify patterns in reading behavior, like whether readers start your book immediately or save it for later. Use this data to optimize your marketing and release timing for maximum reader engagement.'
}, {
  id: 'bounce-rate',
  icon: <ThumbsDownIcon className="w-5 h-5 text-teal-600" data-id="element-5913" data-mp="1xmukdg1tyalp" />,
  title: 'Skim & Bounce Rate',
  description: 'See how many readers flip quickly through content or quit early without engaging.',
  details: 'Identify sections of your book that readers tend to skim through or where they abandon reading altogether. This tool helps you spot potential pacing issues, overlong descriptions, or sections that might benefit from revision. Improve reader retention by addressing problem areas in your narrative.'
}, {
  id: 'return-sessions',
  icon: <Repeat2Icon className="w-5 h-5 text-teal-600" data-id="element-5914" data-mp="1bcvvi88tyamz" />,
  title: 'Return Sessions',
  description: 'Track how many readers come back for a second or third session to finish or re-read.',
  details: "Analyze reader loyalty and engagement by tracking return reading sessions. See how many readers come back to finish your book, how many read it multiple times, and patterns in their return behavior. This metric helps you understand the stickiness of your narrative and your book's rereadability factor."
}, {
  id: 'favorite-sections',
  icon: <BookMarkedIcon className="w-5 h-5 text-teal-600" data-id="element-5915" data-mp="2np16k1tiv1l9" />,
  title: 'Favorite Sections',
  description: 'Highlight chapters or pages that are most frequently revisited or re-read.',
  details: 'Discover which parts of your book readers love most by analyzing revisit patterns. See which chapters, scenes, or pages readers return to multiple times. This insight can inform your future writing by highlighting what resonates most strongly with your audience.'
}, {
  id: 'highlighted-quotes',
  icon: <QuoteIcon className="w-5 h-5 text-teal-600" data-id="element-5916" data-mp="29o6vtcj04ojf" />,
  title: 'Most Highlighted Quotes',
  description: "Show readers' most commonly highlighted or saved lines if annotations are enabled.",
  details: 'See exactly which lines and passages in your book readers find most meaningful or quotable. This feature aggregates reader highlighting data to show you the specific content that resonates most. Great for understanding what prose style connects with readers and for identifying potential social media content.'
}];